module.exports = __webpack_public_path__ + "img/29_60.d8571038.png";